



























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ShowColors extends Vue {
  @Prop(
    { required: false, type: String, default: () => '' },
  ) readonly commaSeparatedColors!: string;

  get colors() {
    return this.commaSeparatedColors.split(',');
  }

  public copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
  }

  public copyLinkToClipboard() {
    this.copyToClipboard(document.URL);
  }
}
